import { API_ENDPOINTS } from "shared/constants";
import { APIService } from "shared/services";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { IStage, IStageCapacity, IStagePatchData } from "Venues/types";

interface IJSONAPIStage {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIStageCollection {
  [IDataKeys.stage]: IJSONAPIStage;
  meta: {
    [key: string]: IJSONAPIItem;
  };
}

export interface IJSONAPICapacityCollection {
  [IDataKeys.stageCapacity]: IJSONAPIStage;
  meta: {
    [key: string]: IJSONAPIItem;
  };
}

export class StageService {
  static createStage = (venueId: string, stage: IStage): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        const { stageCapacities, ...stageData } = stage;

        const createdStage = await APIService.post({
          path: API_ENDPOINTS.STAGES,
          data: {
            ...stageData,
            venue: API_ENDPOINTS.VENUE(venueId),
          },
        });

        resolve(createdStage);
      } catch (error) {
        reject(error);
      }
    });

  static getStage = (id: string): Promise<IJSONAPIStageCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const path = API_ENDPOINTS.STAGE(id);
        const stage: unknown = await APIService.get({ path });
        resolve(stage as IJSONAPIStageCollection);
      } catch (error) {
        reject(error);
      }
    });

  static deleteStage = (stageId: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.STAGE(stageId),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });

  static editStage = (
    stageId: string,
    stage: IStage | IStagePatchData
  ): Promise<IJSONAPIStageCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const patchedStage = await APIService.patch({
          path: API_ENDPOINTS.STAGE(stageId),
          data: stage,
        });
        resolve(patchedStage as IJSONAPIStageCollection);
      } catch (error) {
        reject(error);
      }
    });

  static createCapacity = (stage: string, capacity: IStageCapacity): Promise<IJSONAPIItem> =>
    new Promise(async (resolve, reject) => {
      try {
        // remove id from capacity
        const { id, ...capacityData } = capacity;

        const data = await APIService.post({
          path: API_ENDPOINTS.STAGE_CAPACITIES,
          data: {
            ...capacityData,
            stage,
          },
        });
        resolve(data as IJSONAPIItem);
      } catch (error) {
        reject(error);
      }
    });

  static editCapacity = (
    id: string,
    capacity: IStageCapacity
  ): Promise<IJSONAPICapacityCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const patchedCapacity = await APIService.patch({
          path: API_ENDPOINTS.STAGE_CAPACITY(id),
          data: capacity,
        });
        resolve(patchedCapacity as IJSONAPICapacityCollection);
      } catch (error) {
        reject(error);
      }
    });

  static deleteCapacity = (id: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.STAGE_CAPACITY(id),
        });
        resolve();
      } catch (error) {
        reject(error);
      }
    });
}
